<template>
  <div class="h-full cust_card p-2 mt-2" style="overflow: visible !important;">






    <!-- ===================================================== -->
    <!-- HEADING -->
    <!-- ===================================================== -->

    <div class="heading-3 text-text1">
      ● Bypass Test Phone Number:
    </div>


    <div class="bottom_space rounded py-2 h-full pt-4 bg-white">

      <!-- ===================================================== -->
      <!-- TOP SECTION -->
      <!-- ===================================================== -->

      <div class="bottom_space block justify-between">

        <div class="mb-2 flex items-center justify-between">

          <!-- Search -->
          <div class="flex items-center">

            <div>

              <div style="display:flex"
                class="search_customer_box text-text2 bg-white border border-gray-500 rounded-md px-2 py-1 items-center h-11 mr-4">

                <span class="mr-2 cursor-pointer">
                  <img height="20px" width="20px" src="@/assets/images/svg/gray-search.svg" alt="">
                </span>

                <input class="focus:outline-none w-72 text-text2" autocomplete="off" type="text" placeholder="Search"
                  id="custSearchInput" v-model="searchForCustomer">

                <span v-if="searchForCustomer.length > 0" class="cursor-pointer">
                  <img @click="clearSearch" height="12px" width="12px" src="@/assets/images/svg/clear-input.svg"
                    alt="clearInput">
                </span>

              </div>

            </div>

          </div>


          <!-- Add button -->
          <div>

            <Button @buttonAction="addNewNum" :btnSize="'large'" :textColor="'white'" :btnColor="'primary'"
              :btnText="'Add New Number'" />

          </div>

        </div>

      </div>


      <div>

        <div class="w-full">

          <div class="progress-bar" v-if="searchLoader">
            <div class="progress-bar-value"></div>
          </div>

        </div>


        <!-- ===================================================== -->
        <!-- TABLE -->
        <!-- ===================================================== -->

        <div style="overflow-y: auto; white-space: nowrap;" class="table_containder">

          <!-- Header -->
          <div class="text-text2 min-w-min heaer_row border border-gray1 font-bold flex heading-5 p-1 items-center">

            <!-- Phone Number -->
            <div class="name_col flex items-center p-2">

              <span class="cursor-pointer" :class="titleObj[0].isSel ? 'text-primary' : ''" @click="sortByColumn(0)">
                {{ titleObj[0].title }}
              </span>

              <img v-if="titleObj[0].sortVal === 'DESC'" src="@/assets/images/svg/DESC.svg" />

              <img v-if="titleObj[0].sortVal === 'ASC'" src="@/assets/images/svg/ASC.svg" />

            </div>


            <!-- Action -->
            <div class="name_col flex items-center p-2">

              <span>
                {{ titleObj[1].title }}
              </span>

            </div>

            <div class="name_col flex items-center p-2">

              <span>
                {{ titleObj[2].title }}
              </span>

            </div>

          </div>


          <!-- ===================================================== -->
          <!-- TABLE ROWS -->
          <!-- ===================================================== -->

          <div v-for="data in filteredNumberList" :key="data.id"
            class="min-w-min group flex border-r border-l border-b border-gray1 bg-white text-sm p-1 items-center hover:bg-gray-50">

            <!-- Phone Number -->
            <div class="name_col p-2">

              <span class="heading-4 text-text2">
                {{ formatPhoneNumber(data.phoneNumber) }}
              </span>

            </div>

            <!-- Status -->
            <div class="name_col p-2">

              <span class="heading-4 text-text2">
                {{ data.slug }}
              </span>

            </div>


            <!-- Action -->
            <div class="name_col p-2 flex items-center">

              <!-- Edit -->
              <button type="button" class="mr-4 cursor-pointer focus:outline-none" title="Edit"
                @click.stop="editPhoneNumber(data)">
                <i class="fas fa-xl fa-edit text-primary"></i>
              </button>


              <!-- Delete -->
              <button type="button" class="cursor-pointer focus:outline-none" title="Delete"
                @click.stop="deletePhoneNumber(data)">
                <i class="fas fa-xl fa-trash text-red-500"></i>
              </button>

            </div>

          </div>

        </div>


        <!-- ===================================================== -->
        <!-- NO RECORDS -->
        <!-- ===================================================== -->

        <div class="layout my-2" v-if="!apiLoading && filteredNumberList.length === 0">

          <div class="flex p-3 text-sm text-primary bg-blue-100 rounded-lg items-center" role="alert">

            <svg aria-hidden="true" class="flex-shrink-0 inline w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg">

              <path fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clip-rule="evenodd"></path>

            </svg>

            <span class="sr-only">
              Info
            </span>

            <div>

              <p class="font-medium heading-4">
                No record found.
              </p>

            </div>

          </div>

        </div>

      </div>

    </div>


    <!-- ===================================================== -->
    <!-- ADD / EDIT POPUP -->
    <!-- ===================================================== -->

    <div v-if="showPhonePopup" class="popup_overlay" @click.self="closePhonePopup">

      <div class="popup_box bg-white rounded-lg shadow-xl">

        <!-- Header -->
        <div class="flex items-center justify-between border-b border-gray1 p-4">

          <div class="heading-3 text-text1">
            {{ isEditMode ? 'Edit Phone Number' : 'Add New Phone Number' }}
          </div>

          <button type="button" class="text-text2 text-xl focus:outline-none cursor-pointer" @click="closePhonePopup">
            <i class="fas fa-times"></i>
          </button>

        </div>


        <!-- Body -->
        <div class="p-5">

          <div class="mb-4">

            <label class="block text-text2 heading-5 mb-2">
              Phone Number
            </label>

            <input v-model="phoneForm.phoneNumber" type="text" maxlength="14" placeholder="(000) 000-0000"
              class="phone_input focus:outline-none text-text2 border border-gray-400 rounded-md px-3 py-2 w-full"
              @input="onPhoneInput">

            <div v-if="phoneError" class="text-red-500 text-sm mt-2">
              {{ phoneError }}
            </div>

            <div class="text-gray-500 text-xs mt-2">

              {{ isEditMode ? '' : 'Enter a 10 digit phone number' }}

            </div>

          </div>

        </div>


        <!-- Footer -->
        <div class="flex justify-end border-t border-gray1 p-4">

          <button type="button" class="mr-3 px-4 py-2 rounded-md border border-gray-400 text-text2 focus:outline-none"
            @click="closePhonePopup">
            Cancel
          </button>

          <button type="button" class="px-5 py-2 rounded-md bg-primary text-white focus:outline-none"
            :disabled="savingPhone" @click="savePhoneNumber">

            <span v-if="savingPhone">
              Saving...
            </span>

            <span v-else>
              {{ isEditMode ? 'Update' : 'Add' }}
            </span>

          </button>

        </div>

      </div>

    </div>


    <!-- ===================================================== -->
    <!-- DELETE CONFIRMATION MODAL -->
    <!-- ===================================================== -->

    <div v-if="showDeletePopup" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">

      <div class="bg-white rounded-lg shadow-2xl w-full max-w-md mx-4" @click.stop>

        <!-- Header -->
        <div class="flex items-center justify-between px-5 py-4 border-b border-gray1">

          <div class="flex items-center">

            <div class="flex items-center justify-center w-10 h-10 rounded-full bg-red-100 mr-3">

              <i class="material-icons text-red-500">
                delete
              </i>

            </div>

            <div>

              <div class="text-lg font-semibold text-text1">
                Delete Phone Number
              </div>

              <div class="text-sm text-text2 mt-1">
                Confirm deletion
              </div>

            </div>

          </div>


          <!-- Close -->
          <button type="button" class="text-gray-400 hover:text-gray-600 focus:outline-none" @click="closeDeletePopup">
            <i class="fas fa-times text-lg"></i>
          </button>

        </div>


        <!-- Body -->
        <div class="px-5 py-5">

          <div class="text-sm text-text2">
            Are you sure you want to delete this phone number?
          </div>


          <!-- Phone number -->
          <div class="mt-4 px-4 py-3 rounded-md bg-gray-50 border border-gray1 flex items-center">

            <i class="material-icons text-primary">
              phone_android
            </i>

            <span class="text-base font-semibold text-text1 ml-2">
              {{ deletePhoneData.phoneNumber }}
            </span>

          </div>


          <div class="mt-3 text-sm text-gray-500">
            This action cannot be undone.
          </div>

        </div>


        <!-- Footer -->
        <div class="flex justify-end items-center px-5 py-4 border-t border-gray1">

          <button type="button"
            class="px-5 py-2 mr-3 rounded-md border border-gray-300 text-text2 hover:bg-gray-50 focus:outline-none"
            @click="closeDeletePopup">
            Cancel
          </button>

          <button type="button" class="px-5 py-2 rounded-md bg-red-500 text-white hover:bg-red-600 focus:outline-none"
            :disabled="deletingPhone" @click="confirmDelete">

            <span v-if="deletingPhone">
              Deleting...
            </span>

            <span v-else>
              <i class="fas fa-trash mr-2"></i>
              Delete
            </span>

          </button>

        </div>

      </div>

    </div>

  </div>
</template>


<script>

import Button from '@/View/components/globalButton.vue'

import Api from '@/View/Admin/api/API.js'

export default {

  components: {
    Button
  },

  props: ['orgId'],


  data() {

    return {

      apiLoading: true,
      // =====================================================
      // LOADING
      // =====================================================



      savingPhone: false,

      deletingPhone: false,

      searchLoader: false,


      // =====================================================
      // DELETE
      // =====================================================

      showDeletePopup: false,

      deletePhoneData: {
        id: null,
        phoneNumber: ''
      },


      // =====================================================
      // GENERAL
      // =====================================================

      mobileView: false,

      searchForCustomer: '',


      // =====================================================
      // TABLE HEADERS
      // =====================================================

      titleObj: [

        {
          title: 'Phone Number',
          icon: '',
          sortName: 'phoneNumber',
          sortVal: '',
          isSel: false
        },

        {
          title: 'Status',
          icon: '',
          sortName: '',
          sortVal: '',
          isSel: false
        },
        {
          title: 'Action',
          icon: '',
          sortName: '',
          sortVal: '',
          isSel: false
        }

      ],


      // =====================================================
      // API DATA
      // =====================================================

      NumberList: [],


      // =====================================================
      // ADD / EDIT POPUP
      // =====================================================

      showPhonePopup: false,

      isEditMode: false,

      editingPhoneId: null,

      phoneError: '',

      phoneForm: {
        phoneNumber: ''
      }

    }
  },


  // =====================================================
  // COMPUTED
  // =====================================================

  computed: {

    filteredNumberList() {

      if (!this.searchForCustomer) {
        return this.NumberList
      }

      const searchValue = this.searchForCustomer
        .replace(/\D/g, '')
        .toLowerCase()

      return this.NumberList.filter(data => {

        return String(data.phoneNumber || '')
          .replace(/\D/g, '')
          .includes(searchValue)

      })

    }

  },


  // =====================================================
  // CREATED
  // =====================================================

  created() {

    window.addEventListener(
      'resize',
      this.resizeWindowHandler
    )

  },


  // =====================================================
  // MOUNTED
  // =====================================================

  mounted() {

    this.resizeWindowHandler()

    document.title = 'Bypass Test Phone Number'

    // Load real API data
    this.getOtpBypassList()

  },


  // =====================================================
  // METHODS
  // =====================================================

  methods: {


    // =====================================================
    // AUTH TOKEN
    // =====================================================

    getAuthToken() {


      const empData = JSON.parse(localStorage.getItem('employeeData1'));
      console.log("SuperAdmin Data===>", empData);
      const { saToken } = empData;
      // console.log("SuperAdmin Auth Token===>",saToken);
      // console.log("AuthToken is ==> ",saToken);
      return saToken;


    },


    // =====================================================
    // GET LIST
    // =====================================================

    async getOtpBypassList() {

      this.$store.dispatch('SetLoader', {
        status: true,
        message: 'Loading...'
      })
      try {
        // console.log('1) Enter in getOtpBypassList')

        const authToken = this.getAuthToken();

        // console.log('2) AuthToken exists:', !!authToken, "value===> ",authToken)

        if (!authToken) {
          console.error('Auth token not found')
          this.NumberList = []
          return
        }

        const response = await Api.GetOtpBypassList({
          authToken: authToken
        })

        // console.log('5) OTP Bypass List Response:', response)



        if (
          response &&
          response.success === 1 &&

          Array.isArray(response.Data)
        ) {

          this.apiLoading = false
          const list = response.Data

          console.log('Parsed list:', list)

          this.NumberList = list.map(item => {
            return {
              id: item.bypass_num_id,
              bypass_num_id: item.bypass_num_id,
              phoneNumber: String(item.phoneNumber || ''),
              isActive: item.isActive,
              slug: item.slug
            }
          })

          console.log(
            'Final NumberList:',
            this.NumberList
          )

        } else {

          console.error(
            'Invalid API response:',
            response
          )

          this.NumberList = []

          this.$store.dispatch('SetAlert', {
            showAlert: true,
            message: response?.message || 'Unable to load phone numbers.',
            color: 'error'
          })


        }

      } catch (error) {

        console.error(
          'Error loading OTP bypass list:',
          error
        )

        this.NumberList = []


        this.$store.dispatch('SetAlert', {
          showAlert: true,
          message: error?.message || 'Unable to load phone numbers.',
          color: 'error'
        })


      } finally {

        this.$store.dispatch('SetLoader', {
          status: false,
          message: ''
        })

      }
    }
    ,


    // =====================================================
    // FORMAT PHONE NUMBER
    // =====================================================

    formatPhoneNumber(phoneNumber) {

      const digits = String(phoneNumber || '')
        .replace(/\D/g, '')
        .substring(0, 10)


      if (digits.length <= 3) {

        return digits

      }


      if (digits.length <= 6) {

        return `(${digits.substring(0, 3)}) ${digits.substring(3)}`

      }


      return `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6, 10)}`

    },


    // =====================================================
    // PHONE INPUT
    // =====================================================

    onPhoneInput() {

      const digits = this.phoneForm.phoneNumber
        .replace(/\D/g, '')
        .substring(0, 10)


      this.phoneForm.phoneNumber =
        this.formatPhoneNumber(digits)


      this.phoneError = ''

    },


    // =====================================================
    // ADD NEW
    // =====================================================

    addNewNum() {

      this.isEditMode = false

      this.editingPhoneId = null

      this.phoneForm = {
        phoneNumber: ''
      }

      this.phoneError = ''

      this.showPhonePopup = true

    },


    // =====================================================
    // EDIT
    // =====================================================

    editPhoneNumber(data) {
      console.log("Data in edit phon==> ", data);

      this.isEditMode = true

      this.editingPhoneId =
        data.bypass_num_id || data.id


      this.phoneForm = {

        phoneNumber:
          this.formatPhoneNumber(
            data.phoneNumber
          )

      }


      this.phoneError = ''

      this.showPhonePopup = true

    },


    // =====================================================
    // SAVE
    // =====================================================

    async savePhoneNumber() {

      const phoneNumber =
        this.phoneForm.phoneNumber.replace(/\D/g, '')

      // Validation
      if (phoneNumber.length !== 10) {
        this.phoneError =
          'Please enter a valid 10 digit phone number.'
        return
      }

      // Duplicate check
      if (!this.isEditMode) {

        const alreadyExists =
          this.NumberList.some(data => {
            return String(data.phoneNumber)
              .replace(/\D/g, '') === phoneNumber
          })

        if (alreadyExists) {
          this.phoneError =
            'This phone number already exists.'
          return
        }
      }

      this.phoneError = ''
      this.savingPhone = true

      try {

        const authToken = this.getAuthToken()

        if (!authToken) {
          throw new Error('Authentication token not found.')
        }

        const formData = new URLSearchParams()

        formData.append('authToken', authToken)
        formData.append('phoneNumber', phoneNumber)

        // ==========================================
        // UPDATE
        // ==========================================

        if (this.isEditMode) {

          formData.append(
            'bypass_num_id',
            this.editingPhoneId
          )

          this.$store.dispatch('SetLoader', {
            status: true,
            message: 'Updating...'
          })

          const response = await Api.UpdateOtpBypass({
            authToken: authToken,
            phoneNumber: phoneNumber,
            bypass_num_id: this.editingPhoneId
          })


          console.log(
            'OTP Bypass Update Response in BypassComponent :',
            response
          )

          if (!response || response.success !== 1) {
            throw new Error(
              response?.message ||
              'Unable to update phone number.'
            )
          }

          this.$store.dispatch('SetAlert', {
            showAlert: true,
            message: 'Phone number updated successfully',
            color: 'success'
          })

        }

        // ==========================================
        // ADD
        // ==========================================

        else {

          this.$store.dispatch('SetLoader', {
            status: true,
            message: 'Adding...'
          })

          const response = await Api.AddOtpBypass({
            authToken: authToken,
            phoneNumber: phoneNumber,

          })


          console.log(
            'OTP Bypass Add Response:',
            response
          )

          if (!response || response.success !== 1) {
            throw new Error(
              response?.message ||
              'Unable to add phone number.'
            )
          }

          this.$store.dispatch('SetAlert', {
            showAlert: true,
            message: 'Phone number added successfully',
            color: 'success'
          })
        }

        // Refresh list
        await this.getOtpBypassList()

        this.closePhonePopup()

      } catch (error) {

        console.error(
          'Error saving phone number:',
          error
        )

        this.$store.dispatch('SetAlert', {
          showAlert: true,
          message:
            error?.message ||
            'Unable to save phone number. Please try again.',
          color: 'error'
        })

      } finally {

        this.savingPhone = false

        this.$store.dispatch('SetLoader', {
          status: false,
          message: ''
        })
      }
    }
    ,


    // =====================================================
    // DELETE POPUP
    // =====================================================

    deletePhoneNumber(data) {

      this.deletePhoneData = {

        id:
          data.bypass_num_id ||
          data.id,

        phoneNumber:
          this.formatPhoneNumber(
            data.phoneNumber
          )

      }


      this.showDeletePopup = true

    },


    // =====================================================
    // CLOSE DELETE
    // =====================================================

    closeDeletePopup() {

      this.showDeletePopup = false

      this.deletePhoneData = {

        id: null,

        phoneNumber: ''

      }

    },


    // =====================================================
    // CONFIRM DELETE
    // =====================================================

    async confirmDelete() {

      if (!this.deletePhoneData.id) {
        return
      }

      this.deletingPhone = true

      try {

        const authToken = this.getAuthToken()

        const phoneNumber =
          this.deletePhoneData.phoneNumber
            .replace(/\D/g, '')

        const formData = new URLSearchParams()

        formData.append(
          'authToken',
          authToken
        )

        formData.append(
          'phoneNumber',
          phoneNumber
        )

        this.$store.dispatch('SetLoader', {
          status: true,
          message: 'Deleting...'
        })

        const response =
          await Api.RemoveOtpBypass({
            authToken: authToken,
            phoneNumber: phoneNumber,
            bypass_num_id: this.editingPhoneId
          })

        console.log(
          'OTP Bypass Remove Response:',
          response
        )

        if (!response || response.success !== 1) {
          throw new Error(
            response?.message ||
            'Unable to delete phone number.'
          )
        }

        this.$store.dispatch('SetAlert', {
          showAlert: true,
          message: 'Phone number deleted successfully',
          color: 'success'
        })

        await this.getOtpBypassList()

        this.closeDeletePopup()

      } catch (error) {

        console.error(
          'Error deleting phone number:',
          error
        )

        this.$store.dispatch('SetAlert', {
          showAlert: true,
          message:
            error?.message ||
            'Unable to delete phone number.',
          color: 'error'
        })

      } finally {

        this.deletingPhone = false

        this.$store.dispatch('SetLoader', {
          status: false,
          message: ''
        })
      }
    }
    ,


    // =====================================================
    // CLOSE PHONE POPUP
    // =====================================================

    closePhonePopup() {

      this.showPhonePopup = false

      this.isEditMode = false

      this.editingPhoneId = null

      this.phoneError = ''

      this.phoneForm = {

        phoneNumber: ''

      }

    },


    // =====================================================
    // CLEAR SEARCH
    // =====================================================

    clearSearch() {

      this.searchForCustomer = ''

      this.searchLoader = false

    },


    // =====================================================
    // SORT
    // =====================================================

    sortByColumn(index) {

      if (index !== 0) {
        return
      }


      if (this.titleObj[index].icon === '') {

        this.titleObj[index].icon =
          'fas fa-sort-amount-down'

        this.titleObj[index].sortVal =
          'DESC'

        this.titleObj[index].isSel =
          true


        this.NumberList.sort((a, b) => {

          return String(b.phoneNumber)
            .localeCompare(
              String(a.phoneNumber)
            )

        })

      }


      else if (
        this.titleObj[index].icon ===
        'fas fa-sort-amount-down'
      ) {

        this.titleObj[index].icon =
          'fas fa-sort-amount-up'

        this.titleObj[index].sortVal =
          'ASC'

        this.titleObj[index].isSel =
          true


        this.NumberList.sort((a, b) => {

          return String(a.phoneNumber)
            .localeCompare(
              String(b.phoneNumber)
            )

        })

      }


      else {

        this.titleObj[index].icon =
          'fas fa-sort-amount-down'

        this.titleObj[index].sortVal =
          'DESC'

        this.titleObj[index].isSel =
          true


        this.NumberList.sort((a, b) => {

          return String(b.phoneNumber)
            .localeCompare(
              String(a.phoneNumber)
            )

        })

      }

    },


    // =====================================================
    // RESIZE
    // =====================================================

    resizeWindowHandler() {

      if (window.innerWidth < 684) {

        this.mobileView = true

      } else {

        this.mobileView = false

      }

    }

  },


  // =====================================================
  // BEFORE DESTROY
  // =====================================================

  beforeDestroy() {

    window.removeEventListener(
      'resize',
      this.resizeWindowHandler
    )

  }

}

</script>


<style scoped>
.table_containder {
  padding: 1px;
}


.name_col {
  min-width: 280px !important;
  width: 270px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}


.search_customer_box {
  min-width: 335px !important;
  max-width: 335px !important;
}


.progress-bar {
  height: 2px;
  background-color: rgb(18, 149, 186);
  width: 100%;
  overflow: hidden;
}


.progress-bar-value {
  width: 100%;
  height: 100%;
  background-color: rgb(121, 200, 221);
  animation: indeterminateAnimation 2s infinite linear;
  transform-origin: 0% 50%;
}


@keyframes indeterminateAnimation {

  0% {
    transform: translateX(0) scaleX(0);
  }

  40% {
    transform: translateX(0) scaleX(0.4);
  }

  100% {
    transform: translateX(100%) scaleX(0.5);
  }

}


::placeholder {
  font-size: 16px;
  color: #494949;
}




/* ===================================================== */
/* POPUP */
/* ===================================================== */

.popup_overlay {

  position: fixed;

  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: rgba(0, 0, 0, 0.45);

  display: flex;

  align-items: center;

  justify-content: center;

  z-index: 9999;

}


.popup_box {

  width: 450px;

  max-width: calc(100vw - 30px);

}


/* ===================================================== */
/* PHONE INPUT */
/* ===================================================== */

.phone_input {

  height: 44px;

  font-size: 16px;

}


.phone_input::placeholder {

  color: #d1d5db !important;

}


/* ===================================================== */
/* MOBILE */
/* ===================================================== */

@media screen and (max-width: 600px) {

  .popup_box {

    width: calc(100vw - 30px);

  }


  .search_customer_box {

    min-width: 250px !important;

    max-width: 250px !important;

  }


  .name_col {

    min-width: 220px !important;

    width: 220px !important;

  }

}

.loading_overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: rgba(0, 0, 0, 0.45);

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 10000;
}

.loading_box {
  width: 320px;
  max-width: calc(100vw - 30px);

  padding: 30px;

  text-align: center;
}

.loading_spinner {
  width: 45px;
  height: 45px;

  margin: 0 auto;

  border: 4px solid #e5e7eb;
  border-top: 4px solid #1295ba;

  border-radius: 50%;

  animation: loadingSpin 0.8s linear infinite;
}

@keyframes loadingSpin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
